"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Link = exports.CloseButton = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.red[50],
  borderRadius: '0px 60px 60px 0px',
  bottom: 15,
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  paddingRight: theme.spacing(3),
  position: 'fixed',
  zIndex: 100,
  [theme.breakpoints.up('md')]: {
    bottom: 30
  },
  '&:hover, &:focus': {
    background: theme.palette.red[200]
  }
}));
const Link = exports.Link = (0, _mui.styled)(_mui.Link)(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightBold,
  padding: theme.spacing(3, 0, 3, 3),
  textTransform: 'uppercase',
  '&:hover, &:focus': {
    color: theme.palette.text.primary
  }
}));
const CloseButton = exports.CloseButton = (0, _mui.styled)('button')(({
  theme
}) => ({
  background: 'none',
  border: 'none',
  display: 'flex',
  padding: theme.spacing(3, 0),
  svg: {
    fill: 'inherit'
  }
}));
